import { SEARCH_PAGE_SIZE } from "../constants/CommonConstants";
import { AUDITOR_SEARCH_START_LOADING, AUDITOR_SEARCH_END_LOADING, AUDITOR_SEARCH_LOADED, SET_AUDITOR_FILTER } from "../constants/AuditorConstants";
import { AUDITOR_START_LOADING, AUDITOR_END_LOADING, AUDITOR_LOADED } from "../constants/AuditorConstants";

const initialState = {
    loading: false,
    list: {   
        dataList: []
        , searchList: []
        , totalCount: 0
    },
    filter: {
        pageIndex: 1,
        pageSize: SEARCH_PAGE_SIZE,
        search: "",
        active: ""
    },
    loadingFBO: false,
    fbo: null,
};

const AuditorReducer = (state = initialState, action) => {
    switch(action.type) {
        case AUDITOR_SEARCH_START_LOADING:
            return {
                ...state,
                loading: true
            };
        case AUDITOR_SEARCH_END_LOADING:
            return {
                ...state,
                loading: false
            };
        case AUDITOR_SEARCH_LOADED:
            return {
                ...state,
                list: action.payload
            };
        case SET_AUDITOR_FILTER:
            return {
                ...state,
                filter: action.payload
            };
        case AUDITOR_START_LOADING:
            return {
                ...state,
                loadingFBO: true
            };
        case AUDITOR_END_LOADING:
            return {
                ...state,
                loadingFBO: false
            };
        case AUDITOR_LOADED:
            return {
                ...state,
                fbo: action.payload
            };
        default:
            return state;
    }
}

export default AuditorReducer;